import { useCallback, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import AppShell from '../components/AppShell';
import PrimaryButton from '../components/PrimaryButton';
import { openReferralInApp, openReferralInChrome } from '../deepLink';

function ReferralPage() {
  const { referralCode } = useParams();
  const [searchParams] = useSearchParams();
  const fallbackUrl = `${window.location.origin}${window.location.pathname}?openAttempted=1`;

  const openApp = useCallback(() => {
    openReferralInApp(referralCode);
    window.setTimeout(() => {
      if (document.visibilityState === 'visible') {
        openReferralInChrome(referralCode, fallbackUrl);
      }
    }, 800);
  }, [fallbackUrl, referralCode]);

  useEffect(() => {
    if (!referralCode || searchParams.get('openAttempted') === '1') {
      return;
    }

    const timerId = window.setTimeout(() => {
      openApp();
    }, 500);

    return () => window.clearTimeout(timerId);
  }, [openApp, referralCode, searchParams]);

  return (
    <AppShell>
      <section className="hero compact-hero">
        <div className="hero-badge">Приглашение CryptoFog</div>
        <h1>Открываем приглашение в приложении</h1>
        <p>
          Реферальный код <strong>{referralCode}</strong> будет передан в CryptoFog.
          Если приложение не открылось автоматически, нажми кнопку ниже.
        </p>
        <div className="referral-code-card">
          <span>Ваш код</span>
          <strong>{referralCode}</strong>
        </div>
        <div className="hero-actions">
          <PrimaryButton onClick={openApp}>Открыть приложение</PrimaryButton>
          <PrimaryButton variant="ghost" href="/download">Скачать CryptoFog</PrimaryButton>
        </div>
      </section>
    </AppShell>
  );
}

export default ReferralPage;
